import { Injectable } from '@angular/core';
import { Connect } from '../classes/connect';

declare const grecaptcha: any;

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  private scriptLoaded = false;
  private scriptLoadPromise: Promise<void> | null = null;

  constructor() {
    this.loadScript();
  }

  private loadScript(): Promise<void> {
    if (this.scriptLoaded) {
      return Promise.resolve();
    }

    if (this.scriptLoadPromise) {
      return this.scriptLoadPromise;
    }

    this.scriptLoadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${Connect.recaptchaSiteKey}`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.scriptLoaded = true;
        // Attendi che grecaptcha sia disponibile
        this.waitForGrecaptcha().then(resolve).catch(reject);
      };

      script.onerror = () => reject('Failed to load reCAPTCHA script');

      document.head.appendChild(script);
    });

    return this.scriptLoadPromise;
  }

  private waitForGrecaptcha(): Promise<void> {
    return new Promise((resolve) => {
      const checkInterval = setInterval(() => {
        if (typeof grecaptcha !== 'undefined') {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);
    });
  }

  async executeRecaptcha(action: string): Promise<string> {
    await this.loadScript();

    return new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(Connect.recaptchaSiteKey, { action })
          .then((token: string) => resolve(token))
          .catch((error: any) => reject(error));
      });
    });
  }
}
